// Origen de un cambio auditado (survey_audits.source / config_audits.source).
// Compartido por el historial de registros (calendario, papelera) y el de
// configuración, para que la misma etiqueta signifique lo mismo en toda la app.
//
// Los orígenes "humanos desde la web" (form, autosave, inline_list, calendar,
// builder) no llevan badge: el nombre del usuario ya lo dice todo.
export const SOURCE_LABELS = {
    matrix: 'Matriz',
    file: 'Archivo',
    kanban_sync: 'Tareas',
    api: 'API',
    taimes: 'IA',
    delete: 'Eliminación',
    restore: 'Restauración',
    import: 'Importación',
    duplication: 'Duplicación',
    job: 'Proceso automático',
    console: 'Consola',
};

export const SOURCE_ICONS = {
    matrix: 'fas fa-table',
    file: 'fas fa-paperclip',
    kanban_sync: 'fas fa-columns',
    api: 'fas fa-plug',
    taimes: 'fas fa-robot',
    delete: 'fas fa-trash',
    restore: 'fas fa-undo',
    import: 'fas fa-file-import',
    duplication: 'fas fa-copy',
    job: 'fas fa-cogs',
    console: 'fas fa-terminal',
};

// Ícono y color por tipo de acción en el historial de configuración.
export const ACTION_META = {
    created:  { icon: 'fas fa-plus',  color: '#16a34a', label: 'Creó' },
    updated:  { icon: 'fas fa-pen',   color: '#0061fe', label: 'Editó' },
    deleted:  { icon: 'fas fa-trash', color: '#ef4444', label: 'Eliminó' },
    restored: { icon: 'fas fa-undo',  color: '#16a34a', label: 'Restauró' },
    reordered:{ icon: 'fas fa-sort',  color: '#6b7280', label: 'Reordenó' },
    purged:   { icon: 'fas fa-times', color: '#ef4444', label: 'Borró definitivamente' },
};
